import { queryToPageQsObj } from "../helpers/queryToUrl";

function queryToQs(query = {}) {
  const qsQuery = {
    raw: true,
    limit: query.limit,
    map_pages: query.map_pages,
    ...queryToPageQsObj(query),
  };

  return (
    "?" +
    Object.entries(qsQuery)
      .filter(([, v]) => !!v)
      .map(([k, v]) => `${k}=${v}`)
      .join("&")
  );
}

export const fetchSpaces = (query) =>
  fetch(window.location.pathname + queryToQs(query))
    .then((r) => r.json())
    .catch(() =>
      window.popup.show(
        "Something went wrong while fetching those spaces. Can you try again?",
        { closable: true }
      )
    );
